import Request from "@/common/net/request.js";
const request = new Request();
// 司机列表
export function getDriversPage(data) {
  return request.send({
    url: `/pmy/sys/driver/gps-monitor/drivers/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 司机实时状态
export function getGPSLocation(driverId) {
  return request.send({
    url: `/pmy/sys/driver/gps-monitor/location?driverId=${driverId}`,
    method: "get"
  });
}

// 查询司机轨迹
export function getDriverTracks(data) {
  return request.send({
    url: `/pmy/sys/driver/gps-monitor/tracks`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 查询司机信息(位置信息)
export function getDriversLocation(data) {
  return request.send({
    url: `/pmy/sys/driver/gps-monitor/locations`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 查询司机某时间段内订单信息
export function getDriverOrdersForRangeTime(data) {
  return request.send({
    url: `/pmy/freight/order/freight/driver/points`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
